/**
 * Inventory Store
 *
 * @since 2018-08-20
 * @author Nanhyoung.Ro <dev014>
 */
export const state = () => ({
  apiPreFix: '/api/lr',
  settingApi: '/monitor/setup/logs',
  commandApi: '/command/setup-logs',
  // ===  onSearch ===
  search: {
  },
  logInfoList: [],
  defaultList: []
})

export const actions = {
  // 로그 설정 조회
  async getSearchResult ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.settingApi}`
    try {
      result = await this.$axios.$get(apiUrl, {loading: false})
      if (result.code === 'ok') {
        state.defaultList = result.result
      } else {
        state.defaultList = []
      }

      state.logInfoList = _.cloneDeep(state.defaultList)
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      state.defaultList = []
      state.logInfoList = []
      return result
    }
  },
  async setLogSettings ({commit, state}, updateList) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.settingApi}`
    try {
      result = await this.$axios.$put(apiUrl, {items: updateList}, {loading: false, successAlert: false})
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      return result
    }
  },

  async applySettings ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.commandApi}/apply`
    try {
      result = await this.$axios.$put(apiUrl, null, {applyMsg: true})
      if (result.code === 'ok') {
        state.defaultList = _.cloneDeep(state.logInfoList)
      }
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      state.settingsInfo = {}
      return result
    }
  },

  async cancelSettings ({commit, state}) {
    let result = {}
    const apiUrl = `${state.apiPreFix}${state.commandApi}/cancel`
    try {
      result = await this.$axios.$put(apiUrl, null, {cancelMsg: true})
      return result
    } catch (e) {
      result.code = 'nok'
      result.reason = e
      state.settingsInfo = {}
      return result
    }
  }
}

export const getters = {}
export const strict = false
